import { registerWebserverToken } from '../shared/xomics-webserver-client';

const COOKIE_NAME = 'oncoriskpro-cookie';

function parseCookies() {
  return Object.fromEntries(document.cookie.split(';').map(c => {
    const [k, ...v] = c.trim().split('=');
    return [k, v.join('=')];
  }));
}

function setCookie(id, expiryMs) {
  const value = `${id}|${expiryMs}`;
  document.cookie = `${COOKIE_NAME}=${value}; path=/; expires=${new Date(expiryMs).toUTCString()}; samesite=strict`;
}

function notifyBackend(id) {
  if (!id) return;
  try {
    registerWebserverToken(id).catch((err) => {
      console.error('webserver-cookie error', err);
    });
  } catch (err) {
    console.error('webserver-cookie error', err);
  }
}

export function ensureOncoRiskProCookie() {
  const all = parseCookies();
  const val = all[COOKIE_NAME];
  if (val) {
    const [id, expiry] = val.split('|');
    notifyBackend(id);
    return { id, expiry: parseInt(expiry, 10) };
  }
  const id = crypto.randomUUID();
  const expiry = Date.now() + 180 * 24 * 60 * 60 * 1000;
  setCookie(id, expiry);
  notifyBackend(id);
  return { id, expiry };
}

export function getCookieDaysLeft() {
  const { expiry } = ensureOncoRiskProCookie();
  const diff = expiry - Date.now();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}

export function getCookieId() {
  return ensureOncoRiskProCookie().id;
}
